import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSaltstackComponent } from './simple-icons-saltstack.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSaltstackComponent ],
    exports:      [ SimpleIconsSaltstackComponent ],
    bootstrap:    []
})
export class SimpleIconsSaltstackModule {}
